import { ScheduledAction } from '@demind-inc/core';

import { safeLocalStorage } from '../../utils/safeLocalStorage';

// Mirrors the daily-plan cache (src/helpers/allPlanCache.helpers.ts): the
// pending-job record in jobRecovery.helpers only covers a run that is still
// generating, and is cleared the moment it finishes. Without a separate
// record of the *result*, a refresh right after a plan-my-week run completes
// has nothing left to resume from and the calendar goes back to empty.
const WEEKLY_PLAN_CACHE_KEY = 'lifestack_weekly_plan_cache';

export interface WeeklyPlanCacheEntry {
  weekStart: string;
  numDays: number;
  schedules: ScheduledAction[];
  summary: string | null;
  completedAt: number;
}

export const readWeeklyPlanCache = (): WeeklyPlanCacheEntry | null => {
  const raw = safeLocalStorage.getItem(WEEKLY_PLAN_CACHE_KEY);
  if (!raw) {
    return null;
  }
  try {
    const parsed = JSON.parse(raw) as WeeklyPlanCacheEntry;
    return parsed?.weekStart ? parsed : null;
  } catch {
    return null;
  }
};

export const writeWeeklyPlanCache = (entry: WeeklyPlanCacheEntry): void => {
  safeLocalStorage.setItem(WEEKLY_PLAN_CACHE_KEY, JSON.stringify(entry));
};

export const clearWeeklyPlanCache = (): void => {
  safeLocalStorage.removeItem(WEEKLY_PLAN_CACHE_KEY);
};
